import { render, staticRenderFns } from "./gift-winner.vue?vue&type=template&id=0e125086&"
import script from "./gift-winner.vue?vue&type=script&lang=js&"
export * from "./gift-winner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports